/**
 * Returns a callback to open/close the given component.
 * @param {Element} component
 * @param {boolean} [activeState]
 * @returns {Function} A callback function
 */
const handleToggle = (component, activeState) => () => {
    const nextActiveState = activeState === undefined
        ? $(component).attr('data-active') !== 'true'
        : activeState;

    $(component).attr('data-active', nextActiveState);
};

export default handleToggle;



// WEBPACK FOOTER //
// ./src/scripts/components/common/handleToggle.js